<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <mtc-form-item label="成本项目代码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['code', validatorRules.code]" :trigger-change="true" placeholder="请输入成本项目代码"></a-input>
            </mtc-form-item>
          </a-col>
          <a-col :span="24">
            <mtc-form-item label="成本项目名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['name', validatorRules.name]" :trigger-change="true" placeholder="请输入成本项目名称"></a-input>
            </mtc-form-item>
          </a-col>
          <!--<a-col :span="24">
            <a-form-item label="关联id" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['parentId']" placeholder="请输入关联id"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="数量管理" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['costQty']" placeholder="请输入数量管理"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="肉禽成本" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['poultryCost']" placeholder="请输入肉禽成本"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.remarks')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['remark']" :placeholder="$t('label.pleaseEnterANote')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="是否有效" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['validFlag']" placeholder="请输入是否有效"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="租户信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['tenantCode']" placeholder="请输入租户信息"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="是否删除" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['delFlag']" placeholder="请输入是否删除"></a-input>
            </a-form-item>
          </a-col>-->
          <a-col :span="24">
            <mtc-form-item label="后台备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['notes']" placeholder="请输入后台备注"></a-input>
            </mtc-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'

  export default {
    name: 'EfsCapCostItemForm',
    components: {
      JFormContainer,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
         validatorRules: {
              code: {
                  rules: [
                      { required: true, message: '请输入编码!'},
                      { validator: (rule, value, callback) => validateDuplicateValue('efs_cap_cost_item', 'code', value, this.model.id, callback) }
                  ]
              },
           name: {
                  rules: [
                      { required: true, message: '请输入名称!'},
                  ]
              },
          },
        url: {
          add: "/basicItem/efsCapCostItem/add",
          edit: "/basicItem/efsCapCostItem/edit",
          queryById: "/basicItem/efsCapCostItem/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'code','name','parentId','costQty','poultryCost','remark','validFlag','tenantCode','delFlag','notes'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'code','name','parentId','costQty','poultryCost','remark','validFlag','tenantCode','delFlag','notes'))
      },
    }
  }
</script>